import { defineComponent as h, computed as m, h as d, mergeProps as p } from "vue";
import g from "./ghl-ui.es986.js";
import l from "./ghl-ui.es827.js";
import v from "./ghl-ui.es826.js";
import C from "./ghl-ui.es987.js";
import { useThemeClass as b } from "./ghl-ui.es829.js";
import { formatLength as _ } from "./ghl-ui.es956.js";
import { warn as $ } from "./ghl-ui.es825.js";
const y = Object.assign(Object.assign({}, l.props), {
  depth: [String, Number],
  size: [Number, String],
  color: String,
  component: Object
}), N = h({
  _n_icon__: !0,
  name: "Icon",
  inheritAttrs: !1,
  props: y,
  setup(e) {
    const {
      mergedClsPrefixRef: o,
      inlineThemeDisabled: i
    } = v(e), r = l("Icon", "-icon", g, C, e, o), s = m(() => {
      const {
        depth: t
      } = e, {
        common: {
          cubicBezierEaseInOut: c
        },
        self: a
      } = r.value;
      if (t !== void 0) {
        const {
          color: f,
          [`opacity${t}Depth`]: u
        } = a;
        return {
          "--n-bezier": c,
          "--n-color": f,
          "--n-opacity": u
        };
      }
      return {
        "--n-bezier": c,
        "--n-color": "",
        "--n-opacity": ""
      };
    }), n = i ? b("icon", m(() => `${e.depth || "d"}`), s, e) : void 0;
    return {
      mergedClsPrefix: o,
      mergedStyle: m(() => {
        const {
          size: t,
          color: c
        } = e;
        return {
          fontSize: _(t),
          color: c
        };
      }),
      cssVars: i ? void 0 : s,
      themeClass: n == null ? void 0 : n.themeClass,
      onRender: n == null ? void 0 : n.onRender
    };
  },
  render() {
    var e;
    const {
      $parent: o,
      depth: i,
      mergedClsPrefix: r,
      component: s,
      onRender: n,
      themeClass: t
    } = this;
    return !((e = o == null ? void 0 : o.$options) === null || e === void 0) && e._n_icon__ && $("icon", "don't wrap `n-icon` inside `n-icon`"), n == null || n(), d("i", p(this.$attrs, {
      role: "img",
      class: [`${r}-icon`, t, {
        [`${r}-icon--depth`]: i,
        [`${r}-icon--color-transition`]: i !== void 0
      }],
      style: [this.cssVars, this.mergedStyle]
    }), s ? d(s) : this.$slots);
  }
});
export {
  N as NIcon,
  y as iconProps
};
